import { createPortal } from "react-dom";
import ConfettiExplosion from "react-confetti-explosion"; // or your confetti lib
import { Confetti } from "@Constants/common";

export const ConfettiWrapper = () => {
  const modalRoot =  document.body;

  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center z-[9999] pointer-events-none">
      <ConfettiExplosion
        force={Confetti.FORCE}
        duration={Confetti.DURATION}
        particleCount={Confetti.PARTICLE_COUNT}
        width={Confetti.WIDTH}
      />
    </div>,
    modalRoot
  );
}
